import type { RouteObject } from 'react-router';
import { DiscoveryPage } from './DiscoveryPage';
import { DiscoverySearchPage } from './DiscoverySearchPage';

export const routes: RouteObject[] = [
  { path: '/discover', element: <DiscoveryPage /> },
  { path: '/discover/searches/:id', element: <DiscoverySearchPage /> },
];
